import React from "react";
import { Button, ButtonToolbar, Glyphicon, ListGroupItem } from "react-bootstrap";
import MoveIcon from "../../Widgets/components/Icons/MoveIcon";

import "./styles.scss";

const DraggableBlock = (
    {
        block,
        color = '',
        onEdit,
        onDelete,
        children,
    }
) => {
    function handleDelete() {
        const allow = confirm(`Вы уверены, что хотите удалить ${block.titleRu || block.titleEn}?`);

        allow && onDelete(block.id);
    }

    return (
        <ListGroupItem style={{padding: '0 4px 0 20px'}}>
            <div className="draggable-block">
                <div className="draggable-block col-gap-20">
                    <MoveIcon />
                    <h4
                        className="draggable-block__title"
                        style={{backgroundColor: color ?? '#6E6E6E', color: color ? '#FFFFFF' : '#333333'}}
                    >
                        {block.titleRu ?? block.titleEn}
                    </h4>
                    {children}
                </div>
                <ButtonToolbar>
                    <Button onClick={() => onEdit(block)}>
                        <Glyphicon glyph="pencil" />
                    </Button>
                    <Button onClick={() => handleDelete()}>
                        <Glyphicon glyph="trash" />
                    </Button>
                </ButtonToolbar>
            </div>
        </ListGroupItem>
    );
};

export default DraggableBlock;
